var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('DateRange',{attrs:{"onChange":_vm.onDatesChange}}),_vm._v(" "),(_vm.loaded)?_c('line-chart-original',{attrs:{"data":{
    labels: _vm.labels.map(function (e) { return isNaN(e) ? e : _vm.formatTimestamp(e); }),
      datasets: _vm.lines.map(function (v) { return Object.assign({}, _vm.defaultDataset, v); })
    },"options":{responsive: true, maintainAspectRatio: false}}}):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2152bd6a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/LineChart.vue
// module id = 744
// module chunks = 1